import { FieldError } from 'react-hook-form';
import * as translations from 'shared/locales/en/translation.json';
export const ONLY_SPACES_VALIDATION = 'ONLY_SPACES_VALIDATION';

export const textFieldsValidation = {
  [ONLY_SPACES_VALIDATION]: (value: string) => !value || !!value.trim().length,
};

export const getFieldErrorMessage = (error: FieldError | undefined) => {
  /* istanbul ignore else */
  if (!error) return undefined;
  /* istanbul ignore else */
  if (error.type === ONLY_SPACES_VALIDATION)
    return translations['enterAtLeastOneAlphanumericCharacter'];

  return error.message;
};

export const emailValidation = (email: any) => {
  const emailRegExPattern = new RegExp(
    '^(?<localPart>(?<dotString>(\\b)(?!.*\\.\\.)([0-9a-z!#$%&\'*+-\\/=?^_`\\{|\\}~\\u{80}-\\u{10FFFF}]+)(\\.[0-9a-z!#$%&\'*+-\\/=?^_`\\{|\\}~\\u{80}-\\u{10FFFF}]+)*)|(?<quotedString>"(([\\x20-\\x21\\x23-\\x5B\\x5D-\\x7E\\u{80}-\\u{10FFFF}])|(\\\\[\\x20-\\x7E]))*"))(?<!.{64,})@(?<domainOrAddressLiteral>(?<addressLiteral>\\[((?<IPv4>\\d{1,3}(\\.\\d{1,3}){3})|(?<IPv6Full>IPv6:[0-9a-f]{1,4}(:[0-9a-f]{1,4}){7})|(?<IPv6Comp>IPv6:([0-9a-f]{1,4}(:[0-9a-f]{1,4}){0,5})?::([0-9a-f]{1,4}(:[0-9a-f]{1,4}){0,5})?)|(?<IPv6v4Full>IPv6:[0-9a-f]{1,4}(:[0-9a-f]{1,4}){5}:\\d{1,3}(\\.\\d{1,3}){3})|(?<IPv6v4Comp>IPv6:([0-9a-f]{1,4}(:[0-9a-f]{1,4}){0,3})?::([0-9a-f]{1,4}(:[0-9a-f]{1,4}){0,3}:)?\\d{1,3}(\\.\\d{1,3}){3})|(?<generalAddressLiteral>[a-z0-9-]*[[a-z0-9]:[\\x21-\\x5A\\x5E-\\x7E]+))\\])|(?<Domain>(?!.{64})(([0-9a-z\\u{80}-\\u{10FFFF}]([0-9a-z-\\u{80}-\\u{10FFFF}]*[0-9a-z\\u{80}-\\u{10FFFF}])?))(\\.([0-9a-z\\u{80}-\\u{10FFFF}]([0-9a-z-\\u{80}-\\u{10FFFF}]*[0-9a-z\\u{80}-\\u{10FFFF}])?){2})*))$',
    'ium'
  );
  const validTest = emailRegExPattern.exec(email);
  return emailRegExPattern.test(email) && validTest && !!validTest[0];
};

export const interviewerEmailValidation = (email: any) => {
  const value = String(email ?? '').trim();
  const emailRegex = /^[^\s@]+@[a-zA-Z]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(value);
};

